import { themeWorkspace } from "../../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "matrix",
    name: "%{BKY_CATMATRIX}",
    colour: themeWorkspace.categoryStyles.matrix_category.colour,
    imageName: "/toolbox-imgs/table-solid.svg",
    id: "104",
    contents: [
      {
        kind: "block",
        type: "data_table",
        extraState: {
          itemCount: 4,
        },
        inputs: {
          LINE_1: {
            block: {
              type: "lists_create_with",
              inline: true,
              extraState: {
                itemCount: 3,
              },
              inputs: {
                ADD0: {
                  block: {
                    type: "text",
                    fields: {
                      TEXT: "",
                    },
                  },
                },
                ADD1: {
                  block: {
                    type: "text",
                    fields: {
                      TEXT: "Red",
                    },
                  },
                },
                ADD2: {
                  block: {
                    type: "text",
                    fields: {
                      TEXT: "Blue",
                    },
                  },
                },
              },
            },
          },
          LINE_2: {
            block: {
              type: "lists_create_with",
              inline: true,
              extraState: {
                itemCount: 3,
              },
              inputs: {
                ADD0: {
                  block: {
                    type: "text",
                    fields: {
                      TEXT: "Pencil",
                    },
                  },
                },
                ADD1: {
                  block: {
                    type: "text",
                    fields: {
                      TEXT: "4",
                    },
                  },
                },
                ADD2: {
                  block: {
                    type: "text",
                    fields: {
                      TEXT: "2",
                    },
                  },
                },
              },
            },
          },
          LINE_3: {
            block: {
              type: "lists_create_with",
              inline: true,
              extraState: {
                itemCount: 3,
              },
              inputs: {
                ADD0: {
                  block: {
                    type: "text",
                    fields: {
                      TEXT: "Brush",
                    },
                  },
                },
                ADD1: {
                  block: {
                    type: "text",
                    fields: {
                      TEXT: "1",
                    },
                  },
                },
                ADD2: {
                  block: {
                    type: "text",
                    fields: {
                      TEXT: "3",
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "matrix",
        fields: {
          typeOf: "text",
        },
        inputs: {
          input: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "[[1,2],[2,3]]",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "matrix_3_parameters",
        inputs: {
          lines: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
          columns: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
          callback: {
            block: {
              type: "random_number",
              fields: {
                type: "integer",
              },
              inputs: {
                min: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
                max: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 100,
                    },
                  },
                },
              },
            },
          },
        },
      },

      {
        kind: "block",
        type: "display_element",
        inputs: {
          object: {
            block: {
              type: "latex",
              inputs: {
                LaTeX: {
                  block: {
                    type: "matrix_3_parameters",
                    inputs: {
                      lines: {
                        shadow: {
                          type: "math_number",
                          fields: { NUM: 3 },
                        },
                      },
                      columns: {
                        shadow: {
                          type: "math_number",
                          fields: { NUM: 3 },
                        },
                      },
                      callback: {
                        block: {
                          type: "random_number",
                          fields: { type: "integer" },
                          inputs: {
                            min: {
                              shadow: {
                                type: "math_number",
                                fields: { NUM: 1 },
                              },
                            },
                            max: {
                              shadow: {
                                type: "math_number",
                                fields: { NUM: 100 },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "matrix_determinant",
      },
      {
        kind: "block",
        type: "math_arithmetic",
        fields: {
          OP: "MULTIPLY",
        },
        inputs: {
          A: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
            block: {
              type: "data_table",
              extraState: {
                itemCount: 3,
              },
              inputs: {
                LINE_1: {
                  block: {
                    type: "lists_create_with",
                    inline: true,
                    extraState: {
                      itemCount: 2,
                    },
                    inputs: {
                      ADD0: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 1,
                          },
                        },
                      },
                      ADD1: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: -1,
                          },
                        },
                      },
                    },
                  },
                },
                LINE_2: {
                  block: {
                    type: "lists_create_with",
                    inline: true,
                    extraState: {
                      itemCount: 2,
                    },
                    inputs: {
                      ADD0: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: -3,
                          },
                        },
                      },
                      ADD1: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 2,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          B: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: -1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "math_arithmetic",
        fields: {
          OP: "MULTIPLY",
        },
        inputs: {
          A: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
            block: {
              type: "data_table",
              extraState: {
                itemCount: 3,
              },
              inputs: {
                LINE_1: {
                  block: {
                    type: "lists_create_with",
                    inline: true,
                    extraState: {
                      itemCount: 2,
                    },
                    inputs: {
                      ADD0: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 1,
                          },
                        },
                      },
                      ADD1: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 2,
                          },
                        },
                      },
                    },
                  },
                },
                LINE_2: {
                  block: {
                    type: "lists_create_with",
                    inline: true,
                    extraState: {
                      itemCount: 2,
                    },
                    inputs: {
                      ADD0: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 3,
                          },
                        },
                      },
                      ADD1: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 4,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          B: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: -4,
              },
            },
            block: {
              type: "data_table",
              extraState: {
                itemCount: 3,
              },
              inputs: {
                LINE_1: {
                  block: {
                    type: "lists_create_with",
                    inline: true,
                    extraState: {
                      itemCount: 2,
                    },
                    inputs: {
                      ADD0: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 0,
                          },
                        },
                      },
                      ADD1: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: -1,
                          },
                        },
                      },
                    },
                  },
                },
                LINE_2: {
                  block: {
                    type: "lists_create_with",
                    inline: true,
                    extraState: {
                      itemCount: 2,
                    },
                    inputs: {
                      ADD0: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: -1,
                          },
                        },
                      },
                      ADD1: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 0,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "matrix_short_set",
        inputs: {
          MATRIX: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "matrix",
                  type: "",
                },
              },
            },
          },
          I: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          J: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          VALUE: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 123,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "matrix_short_get",
        inputs: {
          MATRIX: {
            block: {
              type: "variables_get",
              fields: {
                VAR: {
                  name: "matrix",
                  type: "",
                },
              },
            },
          },
          I: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          J: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
    ],
  };
}
